import styled from 'styled-components';
import device from '../../../styles/mediaSizes';

export const StyledCallToAction = styled.div`
  .call-to-action-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-color: #0d2f59;
    border-radius: 9px;
    height: 400px;
    .section-title-wrapper {
      .title {
        width: 60%;
        text-align: center;
        color: #fff;
        margin: 0 auto;
      }
    }

    .button-group {
      margin-top: 25px;
      a,
      button {
        /* margin: 10px; */
      }
      .general-btn {
        margin-top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        border-radius: 8px;
        background: #0777db;
        font-size: 16px;
        font-weight: 400;
        color: #fff;
        text-align: center;
        width: fit-content;
        height: 65px;
        padding: 0 40px;
        transition-duration: 300ms;
        &:hover {
          box-shadow: 0 0 20px 5px rgba(251, 83, 67, 0.2);
          color: #fff;
          background-color: #35c0fb !important;
          text-decoration: none;
        }
        .icon {
          display: none;
          position: relative;
          top: -1px;
          padding-left: 4px;
        }
        .icon svg {
          vertical-align: middle;
          width: 20px;
          height: 20px;
        }
      }
    }

    @media ${device.lg} {
    }

    @media ${device.md} {
      & {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        background-color: #0d2f59;
        border-radius: 9px;
        height: 280px;
        .section-title-wrapper {
          margin-bottom: 0;
          .title {
            width: 70%;
            text-align: center;
            color: #fff;
            margin: 0 auto;
          }
        }

        .button-group {
          margin-top: 25px;
          a,
          button {
            /* margin: 10px; */
          }
          .general-btn {
            margin-top: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 auto;
            border-radius: 8px;
            background: #0777db;
            font-size: 16px;
            font-weight: 400;
            color: #fff;
            text-align: center;
            width: fit-content;
            height: 65px;
            padding: 0 40px;
            transition-duration: 300ms;
            &:hover {
              box-shadow: 0 0 20px 5px rgba(251, 83, 67, 0.2);
              color: #fff;
              background-color: #35c0fb !important;
              text-decoration: none;
            }
            .icon {
              display: none;
              position: relative;
              top: -1px;
              padding-left: 4px;
            }
            .icon svg {
              vertical-align: middle;
              width: 20px;
              height: 20px;
            }
          }
        }
      }
    }

    @media ${device.sm} {
      & {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        background-color: #0d2f59;
        border-radius: 9px;
        height: 230px;
        .section-title-wrapper {
          margin-bottom: 0;
          .title {
            font-size: 27px;
            line-height: 40px;
            width: 100%;
            text-align: center;
            color: #fff;
            margin: 0 auto;
          }
        }

        .button-group {
          margin-top: 25px;
          a,
          button {
            /* margin: 10px; */
          }
          .general-btn {
            margin-top: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 auto;
            border-radius: 8px;
            background: #0777db;
            font-size: 14px;
            font-weight: 400;
            color: #fff;
            text-align: center;
            width: fit-content;
            height: 45px;
            padding: 0 30px;
            transition-duration: 300ms;
            &:hover {
              box-shadow: 0 0 20px 5px rgba(251, 83, 67, 0.2);
              color: #fff;
              background-color: #35c0fb !important;
              text-decoration: none;
            }
            .icon {
              display: none;
              position: relative;
              top: -1px;
              padding-left: 4px;
            }
            .icon svg {
              vertical-align: middle;
              width: 20px;
              height: 20px;
            }
          }
        }
      }
    }
  }
`;
